import type { ResponsiveLayouts } from 'react-grid-layout';
import {
  clearDashboardLayoutPreference,
  loadDashboardLayoutPreference,
  saveDashboardLayoutPreference,
} from './dashboardPreferences';

const LAYOUT_VERSION = 11;
export const LEGACY_TERMINAL_HOME_LAYOUT_STORAGE_KEY = 'tm-grid-layouts-v11';

export const GRID_BREAKPOINTS = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 };
export const GRID_COLS = { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 };
export const GRID_MARGIN: [number, number] = [6, 6];
export const GRID_ROWS = 12;
export const TERMINAL_HOME_PANEL_IDS = [
  'chart',
  'signals',
  'risk',
  'equity',
  'alphaeval',
  'trades',
  'pnl',
  'portfolio',
  'controls',
  'cusum',
  'external',
  'varcone',
  'swaplog',
  'account',
  'orders',
] as const;

export const DEFAULT_LAYOUTS: ResponsiveLayouts = {
  lg: [
    { i: 'chart', x: 0, y: 0, w: 9, h: 5, minW: 4, minH: 3 },
    { i: 'cusum', x: 9, y: 0, w: 3, h: 2, minW: 2, minH: 2 },
    { i: 'signals', x: 9, y: 2, w: 3, h: 3, minW: 2, minH: 2 },
    { i: 'equity', x: 0, y: 5, w: 6, h: 3, minW: 2, minH: 2 },
    { i: 'controls', x: 6, y: 5, w: 3, h: 3, minW: 2, minH: 3 },
    { i: 'risk', x: 9, y: 5, w: 3, h: 3, minW: 2, minH: 2 },
    { i: 'alphaeval', x: 0, y: 8, w: 4, h: 4, minW: 3, minH: 3 },
    { i: 'trades', x: 4, y: 8, w: 4, h: 4, minW: 2, minH: 2 },
    { i: 'pnl', x: 8, y: 8, w: 4, h: 2, minW: 2, minH: 2 },
    { i: 'portfolio', x: 8, y: 10, w: 4, h: 2, minW: 2, minH: 2 },
    { i: 'external', x: 0, y: 12, w: 4, h: 2, minW: 3, minH: 2 },
    { i: 'varcone', x: 4, y: 12, w: 4, h: 2, minW: 3, minH: 2 },
    { i: 'swaplog', x: 8, y: 12, w: 4, h: 2, minW: 2, minH: 2 },
    { i: 'account', x: 0, y: 14, w: 4, h: 2, minW: 3, minH: 2 },
    { i: 'orders', x: 4, y: 14, w: 4, h: 3, minW: 3, minH: 2 },
  ],
  md: [
    { i: 'chart', x: 0, y: 0, w: 10, h: 5, minW: 4, minH: 3 },
    { i: 'cusum', x: 0, y: 5, w: 5, h: 2, minW: 2, minH: 2 },
    { i: 'signals', x: 5, y: 5, w: 5, h: 3, minW: 2, minH: 2 },
    { i: 'equity', x: 0, y: 7, w: 5, h: 3, minW: 2, minH: 2 },
    { i: 'risk', x: 5, y: 8, w: 5, h: 2, minW: 2, minH: 2 },
    { i: 'controls', x: 0, y: 10, w: 5, h: 3, minW: 2, minH: 2 },
    { i: 'alphaeval', x: 5, y: 10, w: 5, h: 4, minW: 3, minH: 3 },
    { i: 'trades', x: 0, y: 13, w: 5, h: 3, minW: 2, minH: 2 },
    { i: 'pnl', x: 5, y: 14, w: 5, h: 2, minW: 2, minH: 2 },
    { i: 'portfolio', x: 0, y: 16, w: 5, h: 2, minW: 2, minH: 2 },
    { i: 'external', x: 5, y: 16, w: 5, h: 2, minW: 3, minH: 2 },
    { i: 'varcone', x: 0, y: 18, w: 5, h: 2, minW: 3, minH: 2 },
    { i: 'swaplog', x: 5, y: 18, w: 5, h: 2, minW: 2, minH: 2 },
    { i: 'account', x: 0, y: 20, w: 5, h: 2, minW: 3, minH: 2 },
    { i: 'orders', x: 5, y: 20, w: 5, h: 3, minW: 3, minH: 2 },
  ],
  sm: [
    { i: 'chart', x: 0, y: 0, w: 6, h: 4, minW: 3, minH: 3 },
    { i: 'cusum', x: 0, y: 4, w: 6, h: 2, minW: 3, minH: 2 },
    { i: 'signals', x: 0, y: 6, w: 6, h: 3, minW: 3, minH: 2 },
    { i: 'equity', x: 0, y: 9, w: 6, h: 3, minW: 3, minH: 2 },
    { i: 'risk', x: 0, y: 12, w: 6, h: 2, minW: 3, minH: 2 },
    { i: 'alphaeval', x: 0, y: 14, w: 6, h: 4, minW: 3, minH: 3 },
    { i: 'controls', x: 0, y: 18, w: 6, h: 3, minW: 3, minH: 2 },
    { i: 'trades', x: 0, y: 21, w: 6, h: 3, minW: 3, minH: 2 },
    { i: 'pnl', x: 0, y: 24, w: 6, h: 3, minW: 3, minH: 2 },
    { i: 'portfolio', x: 0, y: 27, w: 6, h: 2, minW: 3, minH: 2 },
    { i: 'external', x: 0, y: 29, w: 6, h: 2, minW: 3, minH: 2 },
    { i: 'varcone', x: 0, y: 31, w: 6, h: 2, minW: 3, minH: 2 },
    { i: 'swaplog', x: 0, y: 33, w: 6, h: 2, minW: 3, minH: 2 },
    { i: 'account', x: 0, y: 35, w: 6, h: 2, minW: 3, minH: 2 },
    { i: 'orders', x: 0, y: 37, w: 6, h: 3, minW: 3, minH: 2 },
  ],
};

export function saveLayouts(layouts: ResponsiveLayouts): void {
  saveDashboardLayoutPreference({
    scope: 'terminal.home',
    responsiveLayouts: layouts,
    allowedPanelIds: TERMINAL_HOME_PANEL_IDS,
  });
}

export function loadLayouts(): ResponsiveLayouts | null {
  const preference = loadDashboardLayoutPreference('terminal.home', {
    allowedPanelIds: TERMINAL_HOME_PANEL_IDS,
  });
  if (preference?.responsiveLayouts) return preference.responsiveLayouts;

  return loadLegacyLayouts();
}

function loadLegacyLayouts(): ResponsiveLayouts | null {
  try {
    const raw = localStorage.getItem(LEGACY_TERMINAL_HOME_LAYOUT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed.v !== LAYOUT_VERSION) return null;
    return parsed.layouts;
  } catch {
    return null;
  }
}

export function clearLayouts(): void {
  clearDashboardLayoutPreference('terminal.home');
  localStorage.removeItem(LEGACY_TERMINAL_HOME_LAYOUT_STORAGE_KEY);
}

export function calcRowHeight(containerHeight: number): number {
  const gaps = (GRID_ROWS - 1) * GRID_MARGIN[1];
  return Math.max(30, (containerHeight - gaps) / GRID_ROWS);
}
